import React from 'react';
import { Layout, Server, ShoppingCart, Smartphone, Settings, BarChart3 } from 'lucide-react';

const PhilosophyCard = ({ icon: Icon, title, description }) => (
  <div className="bg-white dark:bg-[#111111] p-8 rounded-3xl border border-gray-100 dark:border-gray-800 shadow-sm hover:shadow-xl transition-all duration-300">
    <div className="w-14 h-14 bg-orange-50 dark:bg-primary/10 rounded-2xl flex items-center justify-center mb-6">
      <Icon className="w-7 h-7 text-primary" />
    </div>
    <h3 className="text-xl font-bold mb-3 text-gray-900 dark:text-white">{title}</h3>
    <p className="text-gray-600 dark:text-gray-400 leading-relaxed text-sm">
      {description}
    </p>
  </div>
);

const Webservices = () => {
  const services = [
    { icon: Layout, title: "Custom UI/UX Design", description: "Custom UI/UX design provides creative and impactful solutions that prioritize user-centric design." },
    { icon: Server, title: "Performant Full-Stack", description: "We build performant full-stack applications, ensuring scalability and modern web development standards." },
    { icon: ShoppingCart, title: "E-commerce & Scalability", description: "Robust e-commerce solutions focused on scalability, performance, and seamless user experiences." },
    { icon: Smartphone, title: "Custom UI/D Production", description: "Dedicated to crafting responsive, high-quality digital interfaces for modern web and mobile apps." },
    { icon: Settings, title: "Performant and Scalability", description: "We prioritize clean architecture and scalable code to support your growing business needs." },
    { icon: BarChart3, title: "E-commerce & Analytics", description: "Data-driven development approach, leveraging advanced analytics to optimize conversions and performance." }
  ];

  return (
    <section className="relative py-16 px-6 overflow-hidden bg-[#f8f8f8] dark:bg-[#050505] transition-colors duration-300">
      
      {/* BACKGROUND GLOWS */}
    <div className="absolute top-0 left-0 w-[500px] h-[500px] bg-primary/10 blur-[140px] rounded-full" />
      <div className="absolute bottom-0 right-0 w-[500px] h-[500px] bg-orange-300/10 blur-[140px] rounded-full" />


      {/* CONTENT WRAPPER */}
      <div className="relative z-10 max-w-7xl mx-auto">
             <div className="text-center mb-12 md:mb-16">
                  <h2 className="myheading text-3xl md:text-5xl text-center">
               Our Development {" "}
            <span className="bg-gradient-to-r from-primary via-orange-400 to-yellow-500 bg-clip-text text-transparent">
           Philosophy
            </span>
          </h2>
   <p className="myparagraph text-gray-500">
  Our development solutions encompass website development, and builds performance of web dev.</p>
      </div>
      

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((service, index) => (
            <PhilosophyCard key={index} {...service} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Webservices;